import React, { useCallback, useEffect, useState } from 'react'
import { debounce } from 'lodash'

import DraftsService from '@/app-domains/messages/draft/writing.service'

import useRenderEvent from '@/core/hooks/useRenderEvent'
import sleep from '@/helpers/sleep'

import { SlateEditor } from './components/SlateEditor'

import './styles.sass'
import { useDeviceSelectors } from 'react-device-detect'
import store from '@/core/store'

export const BodyEditor = (props) => {
  const [selectors] = useDeviceSelectors()
  const { isReply } = props
  const [draft, setDraft] = useState(props.draft)
  const [expandedModeSet, setExpandedModeSet] = useState(false)
  const [slateContent, setSlateContent] = useState(props.draft?.slateContent || undefined)
  const debouncedUpdateStore = useCallback(debounce(async (value) => await saveMessageContent(value), 1000), [])

  async function getCleanText () {
    if (isReply) {
    /*
      await sleep reason:

      Avoid race condition while getting the html after a quick update from slate editor
      due this race condition, sometimes we miss the last character of the message.
     */
      await sleep(30)
    }
    const textRaw = document.querySelector('#body-editor')?.innerHTML
    return textRaw || ''
  }

  async function onChangeMessageText (value) {
    if (draft?.type === 'reply') {
      store.commit(`DRAFT_MESSAGE:${props.parentMessageId}:SHOULD_EDIT_ON_MODAL`)
    }
    await debouncedUpdateStore(value)
  }

  async function saveMessageContent (slateContent) {
    if (selectors.isAndroid) {
      return await DraftsService.setMessageBody(isReply ? 'reply' : 'standalone', undefined, slateContent, slateContent)
    }
    const text = await getCleanText()
    if (isReply && !expandedModeSet) {
      props.setShouldEditOnModal(true)
      setExpandedModeSet(true)
    }
    await DraftsService.setMessageBody(isReply ? 'reply' : 'standalone', slateContent, text, text)
  }

  if (isReply) {
    useEffect(() => {
      DraftsService.setDraftType('reply')
    }, [])
  
    useRenderEvent(['DRAFT_MESSAGE:UPDATE'])
  } else {
    useEffect(() => {
      setDraft(props.draft)
      setSlateContent(slateContent || props.draft?.slateContent)
    }, [props.draft])
  }

  return (
    <div className="body-editor-section">
      <SlateEditor
        onEditorValueChange={(isReply || selectors.isAndroid) ? saveMessageContent : onChangeMessageText}
        onChangeMessageText={onChangeMessageText}
        slateContent={slateContent}
        isReply={isReply}
        draft={draft}
        parentMessageId={props.parentMessageId}
      />
    </div>
  )
}
